import httpClient from "@plugins/http";
import { LevelAndStream } from "@modules/level-and-stream/types";
import { ApiResponse } from "@apis/api.ts";

const fetchLevelAndCourseWithContentMap = (params) => {
  return httpClient.get(`/apis/levels-and-courses/grouped`, { params: params });
};

const fetchAllLevelAndCourse = async (params = {}): Promise<ApiResponse<LevelAndStream[]>> => {
  return await httpClient.get(`/apis/levels-and-courses`, { params: params });
};

export default {
  fetchLevelAndCourseWithContentMap,
  fetchAllLevelAndCourse,
};
